import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { VideoModal } from '../../layouts/Modal';
import LazyImage from '../common/LazyImage';

const VideoCard = ({ video, onClick }) => {
  const videoId = getYouTubeID(video);

  return (
    <div
      className="overflow-hidden rounded-lg group cursor-pointer"
      onClick={() => onClick(videoId)}
    >
      <div className="aspect-video relative">
        <LazyImage 
          src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
          alt="Video thumbnail"
          className="w-full h-full"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
            <Play className="w-8 h-8 text-white" />
          </div>
        </div>
        <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
      </div>
    </div>
  );
};

const VideoGrid = ({ videos }) => {
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {videos.map((video, index) => (
          <VideoCard
            key={index}
            video={video}
            onClick={setSelectedVideoId}
          />
        ))}
      </div>

      <VideoModal
        isOpen={!!selectedVideoId}
        onClose={() => setSelectedVideoId(null)}
        videoId={selectedVideoId}
      />
    </>
  );
};

// Utility function to extract YouTube video ID
export const getYouTubeID = (url) => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : false;
};

export default VideoGrid;